import { render, staticRenderFns } from "./LoginBox.vue?vue&type=template&id=7636ec50&scoped=true"
import script from "./LoginBox.vue?vue&type=script&lang=js"
export * from "./LoginBox.vue?vue&type=script&lang=js"
import style0 from "./LoginBox.vue?vue&type=style&index=0&id=7636ec50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7636ec50",
  null
  
)

export default component.exports